module.exports = require("./bem");